import { createContext } from 'react'

const artaContext = createContext()

export default artaContext
